import { useState, useLayoutEffect } from 'react'

/**
 * Returns the amount of pixels we've scrolled from the top of the
 * window.
 */
export function useScrollDistance() {
    const [scrollDistance, setScrollDistance] = useState(window.scrollY)

    useLayoutEffect(() => {
        const scrollHandler = () => {
            setScrollDistance(window.scrollY)
        }

        window.addEventListener('scroll', scrollHandler)

        return () => window.removeEventListener('scroll', scrollHandler)
    })

    return scrollDistance
}
